import { Icons } from 'core/icons';

interface QualityIndicator {
  imageUrl: string;
  backgroundClass: string;
}

export class QualityRating
{
  public static readonly Q1: number = 1;
  public static readonly Q2: number = 2;
  public static readonly Q3: number = 3;
  public static readonly Q4: number = 4;
  public static readonly Q5: number = 5;

  public static getQualityByPercent(qualityInPercent: number): number
  {
    if (qualityInPercent >= 0.28) {
      return QualityRating.Q5;
    }
    else if (qualityInPercent >= 0.25) {
      return QualityRating.Q4;
    }
    else if (qualityInPercent >= 0.17) {
      return QualityRating.Q3;
    }
    else if (qualityInPercent >= 0.1) {
      return QualityRating.Q2;
    }
    else {
      return QualityRating.Q1;
    }
  }

  public static getQualityIndicator(qualityRating: number): QualityIndicator
  {
    switch (qualityRating) {
      case QualityRating.Q5:
      case QualityRating.Q4:
        return {
          imageUrl: Icons.url('good'),
          backgroundClass: 'quality-indication-bg-good'
        };
      case QualityRating.Q3:
        return {
          imageUrl: Icons.url('medium'),
          backgroundClass: 'quality-indication-bg-medium'
        };
      default:
        return {
          imageUrl: Icons.url('bad'),
          backgroundClass: 'quality-indication-bg-bad'
        };
    }
  }
}
